import { AppLinks } from 'app/router/consts/app-links.enum';
import { useNavigate } from 'react-router-dom';

export const authRedirect = () => {
  const navigate = useNavigate();

  return () => {
    navigate(AppLinks.SignInLink);
  };
};
